import { AxiosResponse } from 'axios';
import { Config } from '../config';
import { LoginResponse } from '../types/authTypes';
import apiClient from './apiClient';

export const createBriefing = async (params: {
  title: string;
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.createBriefing,
    params
  );
  return response;
};

export const getBriefing = async (params: {
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.getBriefings,
    params
  );
  return response;
};

export const editBriefing = async (params: {
  briefingId: string;
  title: string;
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.editBriefing,
    params
  );
  return response;
};

export const deleteBriefing = async (params: {
  briefingId: string;
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.deleteBriefing,
    params
  );
  return response;
};

export const publishBriefing = async (params: {
  briefingId: string;
  priorities: {
    storyId: string;
    priority: number;
  }[];
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.publishBriefing,
    params
  );
  return response;
};

export const sendBriefingEmail = async (params: {
  briefingId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.sendEmail,
    params
  );
  return response;
};

export const sendBriefingEmailToPecificUsers = async (params: {
  briefingId: string;
  userIds: string[];
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.sendEmailToUsers,
    params
  );
  return response;
};
